<template>
  <div>
    <div class="columns">

      <div class="column">
        <span class="is-size-3">Contactos de la empresa</span>
      </div>

    </div>

    <div class="mb-20 is-flex justify-flex-end">
      <b-button
        rounded
        type="is-primary"
        icon-right="plus"
        @click="openCreateDialog">
        Agregar usuario
      </b-button>
    </div>

    <div>
      <div class="card">

        <div
        class="card-content"
        v-for="(user, index) in users"
        :key="`user-${index}`">

          <hr v-if="index > 0">

          <div class="columns">

            <div class="column is-2 is-flex is-justify-content-center is-align-items-center">

              <div v-if="user.photo" class="image" style="max-width: 70px">
                <img :src="user.photo.url">
              </div>

              <div v-else>
                <b-field class="file is-blue">
                  <b-upload
                    @input="uploadPhoto( $event, user )"
                    accept=".gif, .jpeg, .jpg, .png"
                    class="file-label"
                    rounded
                    v-model="file">
                    <span class="file-cta">
                        <b-icon
                          class="file-icon"
                          icon="upload">
                        </b-icon>
                        <span class="file-label">
                          Subir foto
                        </span>
                    </span>
                  </b-upload>
                </b-field>
              </div>

            </div>

            <div class="column is-4">

              <div>
                {{ user.fullName }}
              </div>

              <div>
                <a :href="`mailto:${user.email}`">
                  {{ user.email }}
                </a>
                <div>
                  <b-tooltip
                    label="Copiar correo"
                    position="is-bottom">
                    <a>
                      <b-icon
                        class="iconos"
                        icon="copy"
                        v-clipboard:copy="user.email"
                        v-clipboard:error="onError"
                        v-clipboard:success="onCopy">
                      </b-icon>
                    </a>
                  </b-tooltip>

                  <b-tooltip
                    label="Enviar correo"
                    position="is-bottom">
                    <a
                      :href="`https://mail.google.com/mail/u/0/?fs=1&to=${user.email}&tf=cm`"
                      target="_blank">
                      <b-icon
                        class="iconos"
                        icon="envelope-open-text"
                        >
                      </b-icon>
                    </a>
                  </b-tooltip>
                </div>
              </div>

            </div>

            <div class="column">
              <p class="mx-2">
                {{ roles[user.role] }}
              </p>
            </div>

            <div class="column is-2">
              <div class="is-flex is-justify-content-end">
                <b-dropdown
                  :triggers="['hover']"
                  aria-role="list"
                  position="is-bottom-left">
                    <button class="button" slot="trigger">
                      <b-icon icon="ellipsis-stroke"></b-icon>
                    </button>

                    <b-dropdown-item
                      aria-role="listitem"
                      @click="openEdit( user )">
                      <div>
                        <b-icon icon="pencil" /> Editar usuario
                      </div>
                    </b-dropdown-item>

                    <b-dropdown-item
                      aria-role="listitem"
                      @click="inviteContact( user.id )">
                      <div>
                        <b-icon icon="envelope" /> Invitar usuario
                      </div>
                    </b-dropdown-item>

                </b-dropdown>
              </div>
            </div>

          </div>

        </div>

      </div>

      <hr>

      <div class="columns">
        <div class="column is-12">
          <b-pagination
            :current.sync="current"
            :per-page="perPage"
            :range-after="rangeAfter"
            :range-before="rangeBefore"
            :total="total"
            aria-current-label="Current page"
            aria-next-label="Next page"
            aria-page-label="Page"
            aria-previous-label="Previous page"
            order="is-centered"
            rounded
            >
          </b-pagination>
        </div>
      </div>

    </div>

    <UserEdit contactUsers ref="edit" @updated="getUsers"/>

    <UserCreate contactUsers :company="companyId" @updated="getUsers" ref="create"/>

    <b-loading :active.sync="isLoading" />
  </div>
</template>

<script>
import UserEdit from '../components/modals/UserEdit.vue'
import UserCreate from '../components/modals/UserCreate.vue'
import { mapGetters } from 'vuex'
import { validateFileExtension } from '../utils/validateFileExtension.js'

export default {
  components: {
    UserEdit,
    UserCreate,
  },
  data() {
    return {
      validateFileExtension,
      isLoading: false,
      file: null,
      users: [],
      current: 1,
      perPage: 12,
      rangeAfter: 3,
      rangeBefore: 3,
      total: 0,
      roles: {
        'recruiter-manager': 'Coordinador de Adquisición de Talento',
        'recruiter': 'Especialista en Adquisición de Talento',
        'designer': 'Especialista de Comunicación',
        'designer-manager': 'Coordinador de Comunicación',
        'account': 'Analista de Cuentas Clave',
        'account-manager': 'Coordinador de Cuentas Clave',
        'manager': 'Manager',
        'hrmanager': 'Manager de RH',
        'solicitant': 'Solicitante'
      }
    }
  },
  computed: {
    ...mapGetters(['companyId'])
  },
  watch: {
    async current () {
      await this.getUsers()
    }
  },
  methods: {
    async getUsers ( params = null ) {
      this.isLoading = true
      params = params || [
        `skip=${(this.current - 1) * this.perPage}`,
        `limit=${this.perPage}`,
        `fields=fullName,names,paternalSurname,maternalSurname,email,company,role,photo`,
        `sort=role,fullName`
      ].join('&')
      try {
        const { data } = await this.$api.get( `/companies/${this.companyId}/users/company-users?${params}` )
        this.users = data.data
        this.total = data.total
      } catch ( error ) {
        this.$toast.error({
          message: error,
        })
      }
      this.isLoading = false
    },
    openCreateDialog () {
      this.$refs.create.open()
    },
    async uploadPhoto ( event , user ) {
      if (this.file) {
        const isFileValid = await this.validateFileExtension(this.file, ["jpg", "jpeg", "png", "gif"]);
        if (!isFileValid) return; // Detener si falla
      }
      
      this.isLoading = true
      try {
        if (this.file) {
          const formData = new FormData()
          formData.append('file', event)
          await this.$api.post(`/users/${user.id}/upload-photo`, formData,{
            headers: { 'Content-Type': 'multipart/form-data' }
          })
          this.$toast.success({
            message: 'Imagen subida con éxito',
          })
          this.resetPhoto()
          await this.getUsers()
        }
      } catch ( error ) {
        const status = error.response?.status; // Código de estado HTTP
        const data = error.response?.data; // Datos de la respuesta

        if (status === 422 && data?.malicious) {
          // Archivo con malware
          this.$toast.error({
            message: "El archivo que intentas subir es potencialmente peligroso y no puede ser cargado.",
          });
        } else if (status === 415) {
          // Extensión de archivo no válida
          this.$toast.error({
            message: data?.validExtension,
          });
        } else {
          // Otros errores genéricos
          const message = data?.message || error.message || "Error desconocido.";
          this.$toast.error({
            message,
          });
        }
      }
      this.isLoading = false
    },
    resetPhoto () {
      this.file = null
    },
    openEdit ( user ) {
      this.$refs.edit.open(user)
    },
    openAssign (user) {
      this.$refs.assign.open(user)
    },
    async assignCompany (userCompany, val) {
      this.isLoading = true
      try {
        const payload = {
          company: userCompany.company,
          val: val
        }
        await this.$api.post(`/users/${userCompany.user._id}/assign-company`, payload)
        this.$toast.success({
          message: 'Se actualizó exitosamente al usuario',
        })
        await this.getUsers()
      } catch (error) {
        this.$toast.error({
          message: error,
        })
      }
      this.isLoading = false
    },
    onCopy: function () {
      this.$toast.success({
        message: 'Correo copiado correctamente',
      })
    },
    onError: function ( e ) {
      this.$toast.warning({
        message: 'Error al copiar el correo electrónico ' + e.text,
      })
    },
    async inviteContact (userId){
      this.isLoading = true
      try{
        await this.$api.post(`users/invite-contact/${userId}`)
        this.$toast.success({
          message: 'Contacto invitado correctamente'
        })
      }catch(error){
        this.$toast.error({
          message: error,
        })
      }
      this.isLoading = false
    }
  },
  async mounted () {
    await this.getUsers()
  },
}
</script>

<style lang="scss">
.p-sidebar.b-sidebar {
  .sidebar-content {
    width: 50%;
  }
}
</style>
